import React, { ReactElement } from "react";
import { Grid, Typography } from "@material-ui/core";

import Modal from "app/components/modals/Modal";
import { translate } from "infrastructure/translate/localization";
import { hideModal } from "usecases/commons/hide-modal";
import Button from "ui/components/Button";

import useStyles from "./styles";

function ShowLogoutModal(): ReactElement {
  const companyName = localStorage.getItem("company_name");
  const styles = useStyles();

  function handleChangeSociety() {
    window.location.assign("/");
  }

  function logOut() {
    window.location.assign("/logout");
  }

  const isSuperAdmin = window.localStorage.getItem("is_super_admin") === "true";

  return (
    <Modal
      title={`${translate("logout.want-to-exit", {
        societyName: companyName,
      })}`}
    >
      <div>
        <Typography component="p" className={styles.paragraph}>
          {isSuperAdmin
            ? translate("logout.logout-corporate-message")
            : translate("logout.logout-society-message")}
        </Typography>

        <Grid container direction="row" justify="flex-end" spacing={2}>
          <Grid item>
            <Button
              type="button"
              variant="outlined"
              onClick={() => hideModal()}
            >
              {translate("actions.cancel")}
            </Button>
          </Grid>

          {isSuperAdmin && (
            <Grid item>
              <Button type="button" onClick={() => handleChangeSociety()}>
                {translate("actions.change-society")}
              </Button>
            </Grid>
          )}

          <Grid item>
            <Button type="button" onClick={() => logOut()}>
              {translate("actions.exit")}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
}

export default ShowLogoutModal;
